import { IExactScoreBets, ISuperExactScoreEvent } from '@features/super-exact-score/api/superExactScore.type';
import { useSuperExactScoreMakeBetMutation } from '@features/super-exact-score/api/superExactScoreApi';
import SuperExactScoreBonuses from '@features/super-exact-score/components/board/SuperExactScoreBonuses';
import SuperExactScoreCountDown from '@features/super-exact-score/components/board/SuperExactScoreCountDown';
import SuperExactScoreForm from '@features/super-exact-score/components/board/SuperExactScoreForm';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import getUnixTime from 'date-fns/getUnixTime';
import { useSnackbar } from 'notistack';
import React, { FC, useCallback } from 'react';
import { FormattedDate, FormattedMessage, FormattedTime } from 'react-intl';
import { useNavigate } from 'react-router-dom';

interface ISuperExactScoreBoardProps {
  event: ISuperExactScoreEvent
  selectedIndex: number;
  exactScoreId: number;
  exactScoreBets?: IExactScoreBets;
}

const SuperExactScoreBoard:FC<ISuperExactScoreBoardProps> = ({selectedIndex, event, exactScoreId, exactScoreBets}) => {
  const [ exactScore, { error } ] = useSuperExactScoreMakeBetMutation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const currentTimestamp = getUnixTime(new Date());
  const handleSubmit = useCallback(
    (values: any) => {
      exactScore(values).unwrap().then(() => {
        enqueueSnackbar(
          <FormattedMessage id="EXACT_SCORE_PLACE_SUCCESS"/>,
          { variant: 'success' },
        );
        navigate('/my-bets/super-exact-score');
      });
    },
    [ enqueueSnackbar, navigate, exactScore ],
  );
  const onlineTime = (event.onlineTime - currentTimestamp) * 1000;
  const eventTimestamp = event.date * 1000;

  let predictScoreResult = null;
  if (exactScoreBets) {
    predictScoreResult = exactScoreBets[event.id] ? exactScoreBets[event.id]?.predictedScore : '';
  }

  return (
    <Box paddingTop={8} paddingBottom={5} paddingX={2} textAlign="center" maxWidth="sm" marginX="auto" className="super-exact-score-board">
      {event.sport !== undefined && (
        <>
          <Box>
           <SuperExactScoreBonuses/>
            <Typography fontSize="1.4em" textTransform="uppercase">
              {event.champ}
            </Typography>
            <Typography fontSize="1.2em" marginTop={0.5}>
              <FormattedDate day="2-digit" month="long" value={eventTimestamp}/>
              {', '}
              <FormattedTime value={eventTimestamp}/>
            </Typography>
          </Box>

          <Box marginTop={2}>
            <Typography fontSize="1.8em" color="warning.main" className="super-exact-score-predicted-score">
              <FormattedMessage id="PREDICTED_SCORE"/>
            </Typography>
          </Box>

          <SuperExactScoreForm selectedIndex={selectedIndex} event={event} exactScoreId={exactScoreId} exactScoreBets={exactScoreBets} predictedScore={predictScoreResult} errors={error} onSubmit={handleSubmit}/>

          {(event.onlineTime !== undefined && Number(event.onlineTime) > currentTimestamp) && (
            <Box>
              <Typography fontSize="1.8em" color="warning.main">
                <FormattedMessage id="TIME_TO_EXACTSCORE"/>
              </Typography>
              <SuperExactScoreCountDown date={Date.now() + onlineTime}/>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default SuperExactScoreBoard